import bind from 'bind-decorator';

interface Dictionary {
  readonly [k: string]: string;
}

export interface EntryArgs {
  readonly [k: string]: string;
}

export class Translator {
  constructor(private readonly dictionary: Dictionary) { }

  @bind
  public translate(key: string, params?: EntryArgs, fallback: boolean = false) {
    const entry = this.dictionary[key];
    if (!entry) {
      if (fallback) {
        return key;
      }
      throw new Error(`missing translation ${key}`);
    }

    return entry.replace(/[{](\w+)[}]/g, (_, p) => {
      if (!params || !params[p])
        throw new Error(`missing param '${p}' for translation '${key}'`);
      return params[p];
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/i18n/translator.tsx